<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AgendaTaskRow from './AgendaTaskRow.vue';
import { AGENDA_BUCKETS, groupTasksByBucket } from '../../leads/helper';

const props = defineProps({
  tasks: { type: Array, default: () => [] },
  showAssignee: { type: Boolean, default: false },
  resolveTypeName: { type: Function, default: () => '' },
  resolveAssigneeName: { type: Function, default: () => '' },
});
const emit = defineEmits(['edit', 'complete', 'remove']);

const { t } = useI18n();

const BUCKET_LABELS = {
  overdue: 'LEADS.AGENDA.BUCKET.OVERDUE',
  today: 'LEADS.AGENDA.BUCKET.TODAY',
  tomorrow: 'LEADS.AGENDA.BUCKET.TOMORROW',
  week: 'LEADS.AGENDA.BUCKET.WEEK',
  later: 'LEADS.AGENDA.BUCKET.LATER',
};

const grouped = computed(() => groupTasksByBucket(props.tasks));
const buckets = computed(() =>
  AGENDA_BUCKETS.map(key => ({
    key,
    label: t(BUCKET_LABELS[key]),
    tasks: grouped.value[key],
  }))
);
</script>

<template>
  <div
    class="flex flex-col gap-4 md:flex-row md:gap-3 md:overflow-x-auto md:pb-2"
  >
    <section
      v-for="bucket in buckets"
      :key="bucket.key"
      class="flex flex-col gap-2 md:w-72 md:flex-shrink-0"
    >
      <header class="flex items-center justify-between px-1">
        <span
          class="text-xs font-semibold uppercase tracking-wide text-n-slate-11"
        >
          {{ bucket.label }}
        </span>
        <span class="text-xs text-n-slate-10">{{ bucket.tasks.length }}</span>
      </header>
      <ul v-if="bucket.tasks.length" class="flex flex-col gap-1.5">
        <AgendaTaskRow
          v-for="task in bucket.tasks"
          :key="task.id"
          :task="task"
          :type-name="resolveTypeName(task)"
          :assignee-name="resolveAssigneeName(task)"
          :show-assignee="showAssignee"
          @edit="emit('edit', $event)"
          @complete="emit('complete', $event)"
          @remove="emit('remove', $event)"
        />
      </ul>
      <p v-else class="px-1 py-4 text-xs text-center text-n-slate-9">—</p>
    </section>
  </div>
</template>
